import React from 'react';
import { contactInfo, NAME } from '../constants';
import { FaPhone, FaLocationDot , FaClock, FaRegHeart , FaEnvelope } from 'react-icons/fa6';
import { SiInstagram, SiFacebook, SiTiktok } from 'react-icons/si';
import footerLogo from '../img/logo/logo-dark.png'
import './Footer.css';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section-logo">
            <img
              src={footerLogo}
              alt="Psicología Em Gamarro, Emily Gamarro"
              className="footer-logo"
              loading="eager"
              decoding="async"
            />

            <div className="footer-social">
              <a href="https://instagram.com/emgamarro.psicologia" className="social-link" aria-label="Instagram" target="_blank" rel="noopener noreferrer">
                <SiInstagram size={20} color='#F0544F'/>
              </a>
              <a href="https://www.facebook.com/share/1Cd4JkWwuR/?mibextid=wwXIfr" className="social-link" aria-label="Facebook" target="_blank" rel="noopener noreferrer">
                <SiFacebook size={20} color='#F0544F'/>
              </a>
              <a href="https://www.tiktok.com/@113341344_" className="social-link" aria-label="TikTok" target="_blank" rel="noopener noreferrer">
                <SiTiktok size={20} color='#F0544F' />
              </a>
            </div>
          </div>

          <div className="footer-section">
            <h4 className="footer-section-title">Contacto</h4>
            <div className="footer-contact">
              <div className="contact-item">
                <FaPhone className="contact-icon" size={18} />
                <span>+502 {contactInfo.phone}</span>
              </div>
              <div className="contact-item">
                <FaEnvelope className="contact-icon" size={18} />
                <span>{contactInfo.email}</span>
              </div>
              <div className="contact-item">
                <FaLocationDot   className="contact-icon" size={18} />
                <span>Ciudad de Guatemala, Guatemala</span>
              </div>
            </div>
          </div>

          <div className="footer-section">
            <h4 className="footer-section-title">Horarios de atención</h4>
            <div className="footer-schedule">
              <div className="schedule-item">
                <FaClock className="schedule-icon" size={18} />
                <div>
                  <div className="schedule-day">Lunes - Viernes</div>
                  <div className="schedule-time">9:00 - 21:00</div>
                </div>
              </div>
              <div className="schedule-item">
                <FaClock className="schedule-icon" size={18} />
                <div>
                  <div className="schedule-day">Sábados</div>
                  <div className="schedule-time">9:00 - 12:00</div>
                </div>
              </div>
            </div>
          </div>

          <div className="footer-section">
            <h4 className="footer-section-title">Servicios</h4>
            <ul className="footer-services">
              <li>Psicoterapia Individual</li>
              <li>Terapia Integral de Pareja</li>
              <li>Psicoterapia en Cuidado Paliativos</li>
              <li>Terapia Centrada en el Trauma (PAP)</li>
              <li>Servicios Empresariales</li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p className="footer-copyright">
              © {currentYear} {NAME}. Todos los derechos reservados.
            </p>
            <div className="footer-legal">
              <span>Psicóloga Colegiada No. 15936</span>
              <span className="legal-separator">|</span>
              <span>Aviso Legal</span>
              <span className="legal-separator">|</span>
              <span>Política de Privacidad</span>
            </div>
          </div>
          <div className="footer-love">
            <span>Hecho con </span>
            <FaRegHeart  className="heart-icon" size={18} />
            <span> para tu bienestar</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;